// Module
var code = `<div class="alert alert--danger">
  Force closing accounts will be performed for accounts that are active, don't have holds and locks.
  If there is an outstanding accrual on an account, it will be reversed.
</div>

<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.form">
  <table class="table">
    <tbody>
      <tr>
        <td>Product numbers</td>
        <td>
          <file-id-upload
            single-file="true"
            ng-model="\$ctrl.parameters.fileId"
            validate-uploaded
            required
            show-remarks="false"
            enable-webcam="false"
            max-files="1"
            validate="{pattern: '*.csv,*.txt'}"
          ></file-id-upload>
        </td>
      </tr>
      <tr>
        <td>Category</td>
        <td>
          <gl-category-select
            required
            action-type="'DEBIT_ACCOUNT_BY_MEMO'"
            single-accounts-only="true"
            ng-model="\$ctrl.category"
          >
          </gl-category-select>
        </td>
      </tr>
      <tr>
        <td>Remarks</td>
        <td>
          <input
            required
            type="text"
            ng-model="\$ctrl.parameters.remarks"/>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="flex-end">
    <button
      type="button"
      class="btn btn-info"
      ng-click="\$ctrl.downloadSampleFile()">
      Download example
    </button>

    <button
      type="submit"
      class="btn btn-success"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/force-closing-accounts/force-closing-accounts.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;